export default __webpack_public_path__ + "static/media/cardpay_asset.07cbd8f4.svg";